

export const LightningRace1 = () => {
    return (
        <>
            <span>Princess Races este secțiunea dedicată turneelor organizate de Princess Casino sau de partenerii furnizori de jocuri. Verifică termenii fiecărei curse în parte pentru a descoperi cum poți participa și câștiga premii.</span>
            <p><strong>Cursa Fulger</strong></p>
            <ul>
                <li>Promoţia este deschisă participării tuturor persoanelor fizice cu vârsta de peste 18 ani, cu
                    capacitate deplină de exerciţiu și care au un cont activ și verificat pe website-ul
                    PrincessCasino.ro.
                </li>
                <li>Închiderea/Suspendarea/Restricționarea contului din orice motive descalifică utilizatorul din
                    promoție.
                </li>
                <li>CURSA FULGER se desfășoară de la data de 10 Februarie 2021, orele 10:00, până la data de 11
                    Februarie
                    2021, orele 10:00.
                </li>
            </ul>
            <span>Participiare</span>
            <ul>
                <li>Sunt eligibile pentru această cursă toate sloturile, precum și jocurile din categoria “Cazinou
                    Virtual”.
                </li>
                <li>Aduni puncte pe baza multiplicatorului fiecărei runde câștigate. De exemplu: pariezi 2 RON și
                    câștigi 5 RON, vei primi 2,5 puncte.
                </li>
                <li>Punctele se obțin doar la câștiguri mai mari sau egale cu miza.</li>
                <li>Pariul minim pentru această cursă este de 1 RON.</li>
                <li>Punctajul unui jucător este suma tuturor multiplicatorilor obținuți la jocurile eligibile, din
                    pariuri realizate cu bani cash, în perioada desfășurării competiției.
                </li>
            </ul>
            <span>Poți obține un premiu în două feluri:</span>
            <p><strong>Clasament</strong></p>
            <span>Adună cât mai multe puncte și califică-te în top 15 pentru un premiu cash după cum urmează:</span>
            <div className="terms-table">
                <div className="terms-table-header">
                    <div className="terms-table-row">
                        <div className="terms-table-data"><strong>Locul</strong></div>
                        <div className="terms-table-data"><strong>Premii Cursa Fulger</strong></div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">1</div>
                        <div className="terms-table-data">2,500 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">2</div>
                        <div className="terms-table-data">2,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">3</div>
                        <div className="terms-table-data">1,200 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">4</div>
                        <div className="terms-table-data">1,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">5</div>
                        <div className="terms-table-data">800 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">6</div>
                        <div className="terms-table-data">600 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">7</div>
                        <div className="terms-table-data">500 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">8</div>
                        <div className="terms-table-data">400 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">9</div>
                        <div className="terms-table-data">300 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">10</div>
                        <div className="terms-table-data">200 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">11-15</div>
                        <div className="terms-table-data">100 RON</div>
                    </div>
                </div>
            </div>
            <span>Premiile clasamentului  vor fi acordate în balanța CASH, în următoarele 48 de ore de la încheierea competiției.</span>
            <p><strong>Premii Misterioase</strong></p>
            <ul>
                <li>
                    La finalul cursei Fulger, sunt acordate 100 de premii a câte 50 RON Bonus. Premiile sunt acordate
                    aleatoriu pentru 100 de jucători.
                </li>
                <li>Pentru a îndeplini condițiile de retragere ale bonusului jucătorii vor trebui să mizeze de 20x suma
                    primită.
                </li>
                <li>Te asiguri că ești eligibil pentru Premiul Misterios obținând cel puțin 10 puncte în ziua cursei
                    Fulger.
                </li>
                <li>Jucătorii vor fi anunțați pe email și SMS când au primit un premiu.</li>
                <li>În cazul în care este egalitate de puncte între doi jucători, suma totală rulată va fi folosită ca
                    un criteriu de departajare. În situația în care este egalitate perfectă de puncte și de sumă totală
                    rulată pe perioada promoției, premiul va fi împărțit între jucători.
                </li>
                <li>În cazuri de deconectare sau de probleme tehnice generale, toate rotirile afectate sunt anulate și
                    excluse din promoție în scopuri de punctaj.
                </li>
                <li>Oferta respectă Termenii și Condițiile Princess Casino.</li>
                <li>Princess Casino își rezervă dreptul de a suspenda promoția pentru unul sau pentru toți jucătorii,
                    fără explicații sau notificări prealabile, dacă promoția este folosită într-o manieră ce contravine
                    Regulilor Organizatorului. În cazul unui litigiu cu un jucător, decizia Organizatorului va prevala.
                </li>
                <li>Princess Casino își rezervă dreptul de a exclude jucătorii care participă la promoții cu conturi
                    multiple.
                </li>
                <li>Princess Casino își rezervă dreptul de a anula sau modifica termenii și condițiile acestei oferte
                    fără notificare prealabilă.
                </li>
                <li>Pentru orice întrebări legate de prezenta promoție, utilizatorii sunt rugați să contacteze echipa de
                    asistență la adresa de e-mail <a
                        href="mailto:contact@princesscasino.ro">contact@princesscasino.ro</a>.
                </li>
            </ul>
        </>
    )
}